import { Hero } from "@/components/Hero";
import { SmartConsolidation } from "@/components/SmartConsolidation";
import { WhoWeServe } from "@/components/WhoWeServe";
import { SEOHead } from "@/components/SEOHead";
import { useI18n } from "@/hooks/useI18n";

const Index = () => {
  const { t } = useI18n();
  
  return (
    <div className="min-h-screen">
      <SEOHead 
        title={t('seo.home.title')}
        description={t('seo.home.description')}
      />
      <Hero />
      <SmartConsolidation />
      <WhoWeServe />
    </div>
  );
};

export default Index;
